// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "21a547a97585ddf7","191": "2cd7214a365cfe3a","396": "4418011b1208f83e","460": "efb9eb29087b5042","498": "599f444470ef9e05","917": "a26c3bb9981cdf8a","985": "e254a25c3369ebd5",}[chunkId] + ".chunk.js"
}